import {CoursePlanPartVO} from "@/apis/course";
import {CoursePartTypeEnums} from "@/models/course/coursePlanPart";
import {FinishedStatus} from "@/models/live/courseLivePlan";

export default function usePartConvert(): {
  convertPartType: (part: CoursePlanPartVO) => string
} {

  const convertPartType = (part: CoursePlanPartVO): string => {
    switch (part.type) {
      case "RECORDED":
      case "PROJECT":
      case "EXAM":
        return '[' + CoursePartTypeEnums[part.type].text + ']';
      case "LIVE":
        if (part.courseLivePlan?.status) {
          return FinishedStatus.includes(part.courseLivePlan?.status) ? '[回放]' : '[直播]'
        } else {
          return '[直播]';
        }
    }
  }
  return {
    convertPartType
  }
}
